import { render, staticRenderFns } from "./rekonunearneddb.vue?vue&type=template&id=be4083d8&scoped=true"
import script from "./rekonunearneddb.vue?vue&type=script&lang=js"
export * from "./rekonunearneddb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4083d8",
  null
  
)

export default component.exports